'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

function destination() {
  const requested = new URLSearchParams(window.location.search).get('next');
  return requested?.startsWith('/') && !requested.startsWith('//') && requested !== '/login'
    ? requested
    : '/';
}

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    fetch('/api/auth/session', { cache: 'no-store' })
      .then((response) => {
        if (response.ok) window.location.replace(destination());
      })
      .catch(() => {})
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, []);

  async function submit(event) {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setMessage('');
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json().catch(() => null);
      if (!response.ok) {
        throw new Error(data?.error || (response.status >= 500
          ? 'Server login sedang bermasalah. Coba lagi beberapa saat.'
          : 'Login gagal. Periksa username dan password.'));
      }
      if (!data?.user) throw new Error('Respons server login tidak valid. Coba lagi.');
      window.location.replace(destination());
    } catch (error) {
      setMessage(error.message || 'Login gagal. Coba lagi.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="login-title">
        <div className="login-brand"><Image className="login-brand-logo" src="/eranyacloud-logo.png" width={2057} height={420} alt="Eranyacloud" unoptimized /></div>
        <h1 className="login-workspace-title" id="login-title">Workspace internal</h1>
        <form className="login-form" onSubmit={submit}>
          <label htmlFor="login-username">Username</label>
          <input id="login-username" name="username" autoComplete="username" autoCapitalize="none" maxLength={32} value={username} onChange={(event) => setUsername(event.target.value)} required autoFocus />
          <label htmlFor="login-password">Password</label>
          <input id="login-password" name="password" type="password" autoComplete="current-password" maxLength={128} value={password} onChange={(event) => setPassword(event.target.value)} required />
          {message && <p className="login-error" role="alert">{message}</p>}
          <button type="submit" disabled={submitting || checking}>{submitting ? 'Memeriksa akun…' : 'Masuk'}</button>
        </form>
      </section>
    </main>
  );
}
